"use strict";

define('service/pdf',['appkit/service', 'jquery'], function (Service, $) {
  var PDFService = Service.extend({
    replies: {
      'pdf:popup': 'createPopup',
      'pdf': 'createPDF'
    },
    createPopup: function createPopup() {
      var IS_CHROME = String(navigator.userAgent).toLowerCase().indexOf('chrome') !== -1;
      if (!IS_CHROME) {
        var wi = window.open('about:blank', '_blank');
        wi.document.title = "Loading...";
        wi.document.body.innerHTML = "<pre>Loading...</pre>";
        return wi;
      } else return window.open('about:blank', '_blank');
    },
    createPDF: function createPDF(input, externalWindow) {
      var IS_CHROME = String(navigator.userAgent).toLowerCase().indexOf('chrome') !== -1;
      var html = this.stringifyPDFInput(input),
        options = {
          externalWindow: externalWindow,
          formData: {
            html: html,
            downloadForChrome: IS_CHROME
          },
          method: 'POST',
          url: '/rs/api/pdf/create'
        };
      return this.channel.request('download', options);
    },
    stringifyPDFInput: function stringifyPDFInput(input) {
      var outputHtml = "",
        bodyEl = document.createElement('body');
      if (input instanceof $) {
        input = input.get(0);
      }
      if (_.isString(input)) {
        bodyEl.innerHTML = input;
      } else if (_.isElement(input)) {
        if (input.tagName == "BODY") {
          bodyEl = input;
        } else {
          bodyEl.appendChild(input);
        }
      }
      outputHtml = bodyEl.outerHTML;
      return outputHtml;
    }
  });
  return PDFService;
});

